import React from 'react';
import { Forms, SystemText } from 'e4shared';

const Search = ({ runSearch, defaultSearch, competencies, defaultCompetencyIds }) => {
    const [search, setSearch] = React.useState(defaultSearch);
    const [competencyIds, setCompetencyIds] = React.useState(defaultCompetencyIds);

    return (
        <div>
            <div>
                <Forms.Text
                    id="filter-search"
                    label={SystemText('Admin/Forms/FilePicker/Learning360/Search/Label')}
                    help={SystemText('Admin/Forms/FilePicker/Learning360/Search/Help')}
                    placeholder={SystemText('Admin/Forms/FilePicker/Learning360/Search/Placeholder')}
                    value={search}
                    onChange={x => setSearch(x)}
                    onSubmit={() => runSearch(search, competencyIds)}
                    data-testid="text-search-learning360"
                    icon="fa-search"
                />
                <Forms.Select
                    label={null}
                    data={competencies || []}
                    allowMultiple
                    value={competencyIds}
                    onChange={setCompetencyIds}
                    data-testid="select-search-learning360"
                />
            </div>
            <div className="mb10">
                <button
                    data-testid="button-search-learning360"
                    id="search-button"
                    className="btn btn-primary"
                    onClick={() => runSearch(search, competencyIds)}
                >
                    {SystemText('Admin/Forms/FilePicker/Learning360/Button/Search')}
                </button>
            </div>
        </div>
    );
};

export default Search;
